
import request from '../../request';

export default {
  namespaced: true,
  state: {
    loading: false,
    userBalance: null,
    paymentUrl: null,
    payErrors: {},
    waitingForPayment: false,
    card: {
      creating: false,
      created: false,
      error: null,
      type: null,
      form: {
        loaded: false,
        loading: false,
        preregistration_data: undefined,
        access_key: undefined,
        card_registration_url: undefined,
      },
    },
  },
  mutations: {
    setLoading(state, loading) {
      Object.assign(state, { loading });
    },
    setWaitingForPayment(state, waitingForPayment) {
      Object.assign(state, { waitingForPayment });
    },
    setUserBalance(state, val) {
      Object.assign(state, { userBalance: val });
    },
    /*
    setPaymentUrl(state, paymentUrl) {
      Object.assign(state, { paymentUrl });
    },
    */
    setPayErrors(state, payErrors) {
      Object.assign(state, { payErrors });
    },
    setCardFormDataLoaded(state, loaded) {
      Object.assign(state.card.form, { loaded });
    },
    setCardFormDataLoading(state, loading) {
      Object.assign(state.card.form, { loading });
    },
    setCardFormData(state, form) {
      Object.assign(state.card, { form });
    },
    setCreatingCard(state, creating) {
      Object.assign(state.card, { creating });
    },
    setCardCreated(state, created) {
      Object.assign(state.card, { created });
    },
    waitingForPayment(state, waitingForPayment) {
      Object.assign(state, { waitingForPayment });
    },
    setError(state, error) {
      if (error === null) {
        Object.assign(state.card, { error });
      } else if (error === '02625') {
        Object.assign(state.card, { error: 'Invalid card number' });
      } else if (error === '02626') {
        Object.assign(state.card, { error: 'Invalid date. Use MMYY format' });
      } else if (error === '02627') {
        Object.assign(state.card, { error: 'Invalid CCV number' });
      } else if (error === '02628') {
        Object.assign(state.card, { error: 'Transaction refused' });
      } else if (error === '02101') {
        Object.assign(state.card, { error: 'MangoPay is not responding' });
      } else if (error === '09102') {
        Object.assign(state.card, { error: 'Account is locked or inactive' });
      } else if (error === '01902') {
        Object.assign(state.card, { error: 'This card is not active' });
      } else if (error === '02624') {
        Object.assign(state.card, { error: 'Card expired' });
      } else if (error === '02631') {
        Object.assign(state.card, { error: 'Delay exceeded' });
      } else if (error.status_code === 403) {
        Object.assign(state.card, { error: error.message });
      } else {
        Object.assign(state.card, { error: 'Unknown Error' });
      }
    },
    setCardType(state, type) {
      Object.assign(state.card, { type });
    },
  },
  actions: {
    get(context, username) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}wallet/${username}`;
        request.make({
          url,
          type: 'GET',
        }, (err, res) => {
          if (res.status === 200) {
            context.commit('setUserBalance', res.body.data.user.balance);
            resolve();
          }
        });
      });
    },
    createCardInit(context) {
      return new Promise((resolve) => {
        context.commit('setCardFormDataLoaded', false);
        context.commit('setCardFormDataLoading', true);
        context.commit('setPayErrors', {});
        const url = `${process.env.API_URL}card`;
        request.make({
          url,
          type: 'POST',
          data: { card_type: context.state.card.type },
        }, (err, res) => {
          context.commit('setCardFormDataLoading', false);
          if (res.status === 200) {
            // context.commit('setPaymentUrl', res.body.redirect_url);
            context.commit('setCardFormData', res.body.data);
            context.commit('setCardFormDataLoaded', true);
            resolve();
          } else if (res.status === 422) {
            // context.commit('setPayErrors', res.body.errors);
          }
        });
      });
    },
    createCard(context, data) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}card`;

        context.commit('setCreatingCard', true);
        request.make({
          url,
          type: 'PUT',
          data: { data },
        }, (err, res) => {
          context.commit('setCreatingCard', false);
          if (res.status === 201) {
            context.commit('setCardCreated', true);
            resolve();
          }
        });
      });
    },
    /* pay(context) {
      return new Promise((resolve) => {
        context.commit('setPayErrors', {});
        const url = `${process.env.API_URL}payment`;
        context.commit('setWaitingForPayment', true);
        request.make({
          url,
          type: 'POST',
    // data: { action: 'transfer', booking_code: bookingCode },
        }, (err, res) => {
          if (res.status === 200) {
            resolve();
          } else if (res.status === 422) {
            context.commit('setPayErrors', res.body.errors);
          }
          context.commit('setWaitingForPayment', false);
        });
      });
    }, */
    prePay(context) {
      return new Promise((resolve) => {
        context.commit('setPayErrors', {});
        const url = `${process.env.API_URL}pre_payment`;
        context.commit('setWaitingForPayment', true);
        request.make({
          url,
          type: 'POST',
        }, (err, res) => {
          if (res.status === 200) {
            if (typeof res.body !== 'undefined' && res.body !== null) {
              if (typeof res.body.data !== 'undefined') {
                if (typeof res.body.data.SecureModeRedirectURL !== 'undefined') {
                  window.location = res.body.data.SecureModeRedirectURL;
                }
              }
            }
            resolve();
          } else if (res.status === 422) {
            context.commit('setPayErrors', res.body.errors);
          } else if (res.status === 403) {
            context.commit('setError', res.body);
          }
          context.commit('setWaitingForPayment', false);
        });
      });
    },
    verifyPrePay(context, authorizationId) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}pre_payment/${authorizationId}`;
        request.make({
          url,
          type: 'GET',
        }, (err, res) => {
          if (res.status === 200) {
            resolve();
          }
        });
      });
    },
    setError(context, error) {
      context.commit('setError', error);
    },
    setCardType(context, cardType) {
      return new Promise((resolve) => {
        context.commit('setCardType', cardType);
        resolve();
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/public/wallet.js